import React, { useState, useEffect } from "react";
import ChatList from "../screens/ChatList";
import ChatUI from "../screens/ChatUI";
import "../styles/chatui.css";

const SingleChatView = () => {
  const [selectedChat, setSelectedChat] = useState(null);

  const handleChatSelect = (chat) => {
    setSelectedChat(chat);
  };

  return (
    <div className="chat-page-container">
    {!selectedChat ? (
      <div className="chat-list-container">
        <ChatList onSelectChat={handleChatSelect} title="ChatPage" />
      </div>
    ) : (
      <div className="chat-container">
        <ChatUI selectedChat={selectedChat} onBack={() => setSelectedChat(null)} />
      </div>
    )}
    </div>
  );
};

export default SingleChatView;
